import { Modal } from 'components/Modal';
import { FC, useState } from 'react';
import { Button } from 'ui/Button';
import { ReactComponent as Check } from './img/check.svg';
import styles from './OrdersDischargeModal.module.scss';
import { Loader } from '@mantine/core';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import useYandexMetrica from 'hooks/useYandexMetrica';

interface OrdersFinishAllModalTypes {
  setShow: (e: boolean) => void;
  show: boolean;
  onError?: () => void;
  requestBody?: Record<string, unknown>;
  onGenerateDocuments?: (fileId: string) => void;
}

export const OrdersDischargeModal: FC<OrdersFinishAllModalTypes> = ({
  setShow,
  show,
  onError,
  requestBody,
  onGenerateDocuments,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { sendGoal } = useYandexMetrica();

  const handleFinishAllOrders = async () => {
    setIsLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/orders/docs/generate-1c-report`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(requestBody || {}),
        },
      );

      if (!response.ok) {
        if (onError) onError();
        setShow(false);
        return;
      }

      try {
        const result = await response.json();
        if (result?.file_id && onGenerateDocuments) {
          onGenerateDocuments(String(result.file_id));
          setShow(false);
        }
      } catch (e) {
        console.error('Ошибка парсинга ответа при генерации 1С-выгрузки:', e);
        if (onError) onError();
        setShow(false);
      }
    } catch (error) {
      console.error('Ошибка запроса:', error);
      if (onError) onError();
      setShow(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {show && (
        <Modal setOpen={setShow} open={show}>
          <div className={styles.root}>
            <p className={styles.title}>Внимание!</p>

            <p className={styles.info}>
              Некоторые из выбранных заказов еще не завершены. В выгрузку 1С попадут
              только завершённые заказы.
            </p>

            <div className={styles.btn_wrapper}>
              <Button
                onClick={() => setShow(false)}
                theme='outline'
                className={styles.btn_cancel}
                size='L'>
                <IconCancel />
              </Button>
              <Button
                size='L'
                onClick={
                  !isLoading
                    ? () => {
                        handleFinishAllOrders();
                        sendGoal('Export1C');
                      }
                    : undefined
                }
                className={styles.btn}
                theme='filed'>
                <div className={styles.textBtn}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    Подтвердить
                    <div style={{ width: '22px', height: '22px' }}>
                      {isLoading ? (
                        <Loader size='xs' color='white' />
                      ) : (
                        <Check style={{ width: '22px', height: '22px' }} />
                      )}
                    </div>
                  </div>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
